import { render, staticRenderFns } from "./GroovemailForm.vue?vue&type=template&id=6904da42"
import script from "./GroovemailForm.vue?vue&type=script&lang=js"
export * from "./GroovemailForm.vue?vue&type=script&lang=js"
import style0 from "./GroovemailForm.vue?vue&type=style&index=0&id=6904da42&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports